<template>
  <div class="class-select">
    <p class="m-title">请您选择需要管理学员的班级</p>
    <ul class="class-list frc">
      <template v-for="(item, index) in classData">
        <li v-bind:class="index == classListIndex ? 'menu-select' : ''" v-bind:key="index"
          v-on:click="classListIndexTap(index)">
          <img v-bind:src="item.icon" alt="">
          <p v-bind:class="index == classListIndex ? 'menu-select' : ''">{{item.classerName}}</p>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "ClassSelect",
    components: {},
    props:["classData","classListIndex"],
    data () {
      return {

      };
    },
    mounted () {
      
    },
    methods: {
      classListIndexTap (index) {
        this.$emit("changeClass",index);
      }
    }
  };
</script>

<style scoped lang="scss">
  $bgc: #F5F7FA;
  $commonColor: #20a0ff;

  .class-select {
    margin: 0px 0px 10px 0px;

    .m-title {
      padding: 14px 14px 14px 14px;
      border-radius: 6px;
      background-color: $bgc;
    }

    .class-list {
      padding: 20px 20px 20px 20px;
      flex-wrap: wrap;

      li {
        width: 124px;
        margin: 0px 8px;
        padding: 6px 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }

    .menu-select {
      background-color: #f5f7fa;
      color: $commonColor;
    }
  }
</style>